import Navbar from "@/components/navbar/Navbar.vue";

export default {
    name: "Home",
    props: {},
    data() {
        return {
            urbanSectors: this.$store.getters.getUrbanSectors,
            urbanEnvironments: this.$store.getters.getUrbanEnvironments,
            geography: this.$store.getters.getGeography,
            // typeOfSolution: this.$store.getters.getTypeOfSolution,
            projects: this.$store.getters.getProjects,

            activeUrbanSectors: null,
            activeUrbanEnvironments: null,

            urbanEnvironmentOrGeogrphy: this.$store.getters.getActiveUrbanEnvironmentOrGeography,
            imageSvgUrbanSector: null,
            imageSvgGeogrphy: null,
            sectionsMobile: {},

            hoverPathTmp: null
        };
    },
    computed: {},
    created() {
        this.resetSvgToInit();
    },
    mounted() {
        console.log('version:', this.$store.getters.getFeVersion)
        console.log("ENV: ", process.env.VUE_APP_ENV)
        this.initEventMappaUrbanEnvironments();
        this.initEventMappaGeogrphy();
        this.sectionsMobile = this[this.urbanEnvironmentOrGeogrphy].map(section => section.key)
    },
    components: {
        Navbar
    },
    methods: {
        initEventMappaUrbanEnvironments() {
            let mappaIsometricaObj = document.getElementById('urbanenvironments-map');
            // console.log('mappaIsometricaObj', mappaIsometricaObj)

// on click
            mappaIsometricaObj.addEventListener("load", eventLoad => {

                this.imageSvgUrbanSector = eventLoad.target.contentDocument
                // console.log('imageSvgUrbanSector', this.imageSvgUrbanSector);

                this.imageSvgUrbanSector.addEventListener('click', eventClick => {
                    eventClick.preventDefault();

                    // https://www.w3schools.com/jsref/event_composedpath.asp
                    // let arrayPath = eventClick.path;
                    let arrayPath = eventClick.composedPath();
                    let placeObj = this.getKeyFromArrayPath(arrayPath, this.urbanEnvironments);
                    // this.resetSvgToInit(this.imageSvgUrbanSector);

                    // console.log('placeObj', placeObj)
                    if (placeObj) {
                        let urbanEnvironmentSelected = this.urbanEnvironments.find(item => item.svgId === placeObj.id);
                        // console.log('urbanEnvironmentSelected', urbanEnvironmentSelected)
                        this.goToRoute(urbanEnvironmentSelected.key);
                    }
                    // this.highlightsElement(placeObj);
                });


// on hover
                this.imageSvgUrbanSector.addEventListener('mouseover', mouseOver => {
                    let arrayHover = mouseOver.composedPath();
                    let placeObjHover = this.getKeyFromArrayPath(arrayHover, this.urbanEnvironments, this.sectionsMobile);
                    if (placeObjHover) {
                        this.setCircleHover(placeObjHover);
                    }

                });

                this.imageSvgUrbanSector.addEventListener('mouseleave', mouseLeave => {
                    this.setCircleHover(null);
                });

            });
        },

        initEventMappaGeogrphy() {
            let mappaGeograficaObj = document.getElementById('geography-map');
            // console.log('mappaIsometricaObj', mappaIsometricaObj)

            mappaGeograficaObj.addEventListener("load", eventLoad => {

                this.imageSvgGeogrphy = eventLoad.target.contentDocument
                // console.log('imageSvg', this.imageSvgGeogrphy);

                this.imageSvgGeogrphy.addEventListener('click', eventClick => {
                    eventClick.preventDefault();

                    // https://www.w3schools.com/jsref/event_composedpath.asp
                    // let arrayPath = eventClick.path;
                    let arrayPath = eventClick.composedPath();
                    // console.log('arrayPath', arrayPath)
                    let placeObj = this.getKeyFromArrayPath(arrayPath, this.geography);
                    // this.resetSvgToInit(this.imageSvgGeogrphy);

                    // console.log('placeObj', placeObj)
                    if (placeObj) {
                        let geographySelected = this.geography.find(item => item.svgId === placeObj.id);
                        // console.log('geographySelected', geographySelected)
                        this.goToRoute(geographySelected.key);
                    }
                    // this.highlightsElement(placeObj);
                });

                // on hover
                this.imageSvgGeogrphy.addEventListener('mouseover', mouseOver => {
                    let arrayHover = mouseOver.composedPath();
                    let placeObjHover = this.getKeyFromArrayPath(arrayHover, this.geography, this.sectionsMobile);
                    if (placeObjHover) {
                        this.setCircleHover(placeObjHover);
                    }

                });

                this.imageSvgGeogrphy.addEventListener('mouseleave', mouseLeave => {
                    this.setCircleHover(null);
                });

            });
        },

        // TOOLS   ----------------------------
        getKeyFromArrayPath(arrayPath, array, filter = null) {
            let ret;
            arrayPath.forEach(path => {
                let obj = array.find(item => item.svgId === path.id);
                if (obj && filter == null) {
                    ret = path;
                } else if (obj && filter != null) {
                    if (filter.includes(obj.key)) {
                        ret = path;
                    }
                }

            })
            return ret;
        },


        resetSvgToInit() {
            this.activeUrbanSectors = null;
            this.$store.commit('setActiveUrbanSectors', {});
            this.sectionsMobile = this[this.urbanEnvironmentOrGeogrphy].map(section => section.key);
            if (this.urbanEnvironmentOrGeogrphy === 'urbanEnvironments') {
                this.urbanEnvironments.forEach(item => {
                    // console.log('item.svgId', item.svgId)
                    if (this.imageSvgUrbanSector) {
                        let element = this.imageSvgUrbanSector.getElementById(item.svgId)
                        if (element)
                            element.style = null;
                    }
                })
            } else if (this.urbanEnvironmentOrGeogrphy === 'geography') {
                this.geography.forEach(item => {
                    // console.log('this.imageSvgGeogrphy', this.imageSvgGeogrphy)
                    if (this.imageSvgGeogrphy) {
                        let element = this.imageSvgGeogrphy.getElementById(item.svgId)
                        if (element)
                            element.style = null;
                    }
                })
            }

        },

        highlightsElement(placeObj) {
            // placeObj.appendChild(this.makeRectangle(this.imageSvg));
            // placeObj.innerHTML = '<feGaussianBlur stdDeviation="5" />';
            // placeObj.style.filter = "grayscale(150%)";
            placeObj.style.filter = "opacity(0.2)";
            // placeObj.style.filter = "url(#dropShadow)";
            // placeObj.style.filter = "drop-shadow(2px 4px 6px black)";
            // placeObj.style.filter = "drop-shadow(0px -10px 8px #fff)";
        },

        setCircleHover(placeObjHover) {
            let circleBgDefault = '#775EFD';
            let circleBgHover = '#FFFFFF';
            let pathBgDefault = '#FFFFFF';
            let pathBgHover = '#775EFD';

            if (this.hoverPathTmp) {
                let ctaObj = this.hoverPathTmp.querySelectorAll("[id*='CTA']")[0];
                ctaObj.querySelector('circle').style.fill = circleBgDefault;
                let paths = ctaObj.querySelectorAll('path');
                paths.forEach(item => item.style.fill = pathBgDefault)
            }

            if (placeObjHover) {
                let ctaObj = placeObjHover.querySelectorAll("[id*='CTA']")[0];
                ctaObj.querySelector('circle').style.fill = circleBgHover;
                let paths = ctaObj.querySelectorAll('path');
                paths.forEach(item => item.style.fill = pathBgHover)

                this.hoverPathTmp = placeObjHover;
            }

        },

        urbanSectorClick(urbanSector) {
            if (this.activeUrbanSectors === urbanSector) {
                this.resetSvgToInit();
                return;
            } else {
                this.resetSvgToInit();
            }

            // console.log('this.imageSvgUrbanSector', this.imageSvgUrbanSector)
            this.activeUrbanSectors = urbanSector;
            this.$store.commit('setActiveUrbanSectors', this.activeUrbanSectors);
            // console.log('urbanSector', urbanSector)
            let difference = {};
            if (this.urbanEnvironmentOrGeogrphy === 'urbanEnvironments') {
                difference = this.urbanEnvironments
                    .filter(x => !urbanSector.urbanEnvironments.includes(x.key))
                    .map(y => y.key);

                difference.forEach(urbanTohighlights => {
                    let svgObj = this.urbanEnvironments.find(item => item.key === urbanTohighlights);
                    if (svgObj && this.imageSvgUrbanSector) {
                        let element = this.imageSvgUrbanSector.getElementById(svgObj.svgId);
                        this.highlightsElement(element);
                    }
                })
            } else {
                difference = this.geography
                    .filter(x => !urbanSector.geography.includes(x.key))
                    .map(y => y.key);

                difference.forEach(urbanTohighlights => {
                    let svgObj = this.geography.find(item => item.key === urbanTohighlights);
                    if (svgObj && this.imageSvgGeogrphy) {
                        let element = this.imageSvgGeogrphy.getElementById(svgObj.svgId);
                        this.highlightsElement(element);
                    }
                })
            }
            this.sectionsMobile = this[this.urbanEnvironmentOrGeogrphy].filter(x => urbanSector[this.urbanEnvironmentOrGeogrphy].includes(x.key)).map(y => y.key);

            // ANALYTICS
            var enelDataChips = {
                event: {
                    chip: this.activeUrbanSectors.id,
                    component: 'Chips_UrbanSector'
                },
            }
            window.satelliteTrack('click_chip', enelDataChips);
        },

        changeSvg(urbanEnvironmentOrGeogrphy) {
            this.urbanEnvironmentOrGeogrphy = urbanEnvironmentOrGeogrphy;
            this.resetSvgToInit();

        },

        goToRoute(section) {
            if (this.activeUrbanSectors && !this.activeUrbanSectors[this.urbanEnvironmentOrGeogrphy].includes(section)) {
                return;
            }
            // // let urbanSector = this.$store.getters.getUrbanSectorsFromUrbanEnvironment(activeUrbanEnvironment)
            this.$router.push({
                name: 'sectionDetail',
                params: {
                    urbanEnvironmentOrGeography: this.urbanEnvironmentOrGeogrphy.toLowerCase(),
                    // urbanSector: (urbanSector) ? urbanSector.id.toLowerCase() : 'all',
                    section: section.toLowerCase(),

                }
            })
        },

    }
};
